import axios from "axios";
import React, { useEffect, useState } from "react";
import globalVariables from "../global-variables";
import { Link } from "react-router-dom";

export default function FacultyListForSearch({ res_id ,setCurrentPage, setSelectedFocusAreas, setSelectedFocusAreasName, setSelectedDepartment, setSelectedDepartmentName, setFilterState }) {
  const [resFacultyList, setresFacultyList] = useState([]);

  useEffect(() => {
    const fetchFaculty = () => {
      let _obj = { res_fac_res_id: res_id };
      //get faculty list
      axios
        .post(
          globalVariables.variables.strApiUrl +
            "/researchApi/getmappedResearchFacultyList",
          _obj
        )
        .then((response) => {
          setresFacultyList(response.data[0]);
        });
    };

    if (res_id) {
      fetchFaculty();
    }
  }, [res_id]);

  return (
    <>
      {resFacultyList.length > 0 && (
        <li className="list-group-item border-0 px-0 py-0 bg-transparent">
          <span className="text-black fw-medium">Faculty:</span>{" "}
          {resFacultyList.map((faculty, i) => {
            return (
              <>
                <span key={i}>
                  {" "}
                  <Link
                    onClick={() => {
                      setCurrentPage(1);
                      setSelectedFocusAreas([]);
                      setSelectedFocusAreasName([]);
                      setSelectedDepartment([]);
                      setSelectedDepartmentName([]);
                      setFilterState((prev) => ({
                        ...prev,
                        resStr: null,
                        facultyId: faculty.res_faculty_id,
                        sdg_id: null,
                        faculty_name: faculty.res_faculty_name,
                        sdg_name: null,
                      }));
                    }}
                    to={`/research-projects/search-result`}
                    state={{
                      facultyId: faculty.res_faculty_id,
                      faculty_name: faculty.res_faculty_name,
                      sdg_id: null,
                      sdg_name: null,
                      resStr: null,
                      focusAreaId: null,
                      focusAreaName: null,
                    }}
                    key={faculty.res_faculty_id}
                  >
                    {faculty.res_faculty_name}
                  </Link>
                </span>
                {i < resFacultyList?.length - 1 && ","}
              </>
            );
          })}
        </li>
      )}
    </>
  );
}
